import { Divider, Stack } from '@srichaitra/ui';
import { Page, ProfitLossPanel, TrendsPanel } from '@srichaitra/common';
import { labels } from '@srichaitra/constants';

/**
 * The business dashboard — the first thing seen after signing in.
 *
 * Two sections, in the order the questions get asked: *did we make money*, then
 * *where did it come from*. The profit figure is the page's hero and the only
 * thing set at that size, so the eye lands on the answer before it lands on
 * anything explaining it.
 *
 * A rule divides them rather than more whitespace. The two sections are scoped
 * differently — profit is all-time, trends are one selected year — and a visible
 * break is what stops the year control up in the Trends header from looking as
 * though it filters the figures above it too.
 *
 * Each panel loads what it needs and says for itself when a role is not
 * entitled to the figures behind it, so this page is only the running order.
 * Nothing is calculated here: the definitions live on the server, and a second
 * implementation in the browser would drift from the one the mobile client
 * uses.
 */
export function DashboardPage() {
  return (
    <Page title={labels.dashboard.heading} description={labels.dashboard.description}>
      <Stack gap={8}>
        <ProfitLossPanel />
        <Divider />
        <TrendsPanel />
      </Stack>
    </Page>
  );
}
